<template>
    <div class="filter-icon-wrapper / flex" :class="{isSelected}" @click="handleClick">
        <span v-if="isProjectListTabletScreen" class="filter-icon-wrapper_title">{{ t('projectclient.projectlist.topbar.button.filter') }}</span>
        <VJoyIcon class="filter-icon-wrapper_icon" name="filter" :size="isMobileScreen ? 'xsmall' : 'xxsmall'" />
        <div v-if="isSelected" class="filter-icon-wrapper_selected / flex">
            <span class="filter-icon-wrapper_selected_count">{{ selectedFiltersCount }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {useScreenSizeStore} from '@common/stores';
    import {storeToRefs} from 'pinia';
    import {useTranslation} from '#imports';
    import {VJoyIcon} from '@maltjoy/core-vue';
    import {useProjectsListFiltersStore} from '~/features/projects-list/stores';
    import {eventBus} from '@/common/events';

    const {t} = useTranslation();

    const screenSizeStore = useScreenSizeStore();
    const {isProjectListTabletScreen, isMobileScreen} = storeToRefs(screenSizeStore);

    const projectListFilters = useProjectsListFiltersStore();
    const {selectedFiltersCount} = storeToRefs(projectListFilters);

    const isSelected = computed(() => selectedFiltersCount.value > 0);

    const emit = defineEmits<{
        click: [];
    }>();

    function handleClick() {
        eventBus.emit('openProjectListFilterDrawer');
        emit('click');
    }
</script>

<style lang="scss" scoped>
    .filter-icon-wrapper {
        border: 2px solid var(--joy-color-neutral-30);
        border-radius: var(--joy-core-radius-3);
        padding: var(--joy-core-spacing-2);
        height: 44px;
        min-width: 44px;
        width: fit-content;
        align-items: center;
        justify-content: center;
        transition: border-color var(--joy-transition-duration-default) var(--joy-transition-timing-function);

        &_title {
            color: var(--joy-color-neutral-60);
            font-size: var(--joy-font-size-primary-300);
            margin-right: var(--joy-core-spacing-2);
        }

        &_selected {
            margin: 0 var(--joy-core-spacing-2);
            align-items: center;

            &_count {
                background-color: var(--joy-color-secondary-30);
                color: var(--joy-color-neutral-0);
                border-radius: var(--joy-core-radius-4);
                padding: 1px var(--joy-core-spacing-2);
                display: inline-flex;
                align-items: center;
                padding-bottom: 2px;
                font-size: var(--joy-font-size-primary-200);
            }
        }

        &.isSelected {
            background-color: var(--joy-color-secondary-10);
            border: 2px solid var(--joy-color-secondary-30);
        }

        &_icon {
            color: var(--joy-color-neutral-60);
        }

        &:hover,
        &:focus {
            cursor: pointer;
            border: 2px solid var(--joy-color-secondary-30);
        }
    }
</style>
